import { breadcrumb } from './breadcrumb.reducer';
import { dashboard } from "./dashboard.reducer";

export default {
  breadcrumb,
  dashboard
}